import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import { AppConfigContext } from '@providers/AppConfigProvider';

interface Props {
  onClick: () => void;
}

export default function MenuOpenIcon({ onClick }: Props): React.JSX.Element {
  const { pathRoot } = useContext(AppConfigContext);
  return (
    <Box className="group fixed z-[1000] top-4 right-12 max-md:top-3 max-md:right-5 cursor-pointer" onClick={onClick}>
      <img
        src={`${pathRoot}/assets/images/common/circle_red.svg`}
        alt="menu_open_icon"
        className="menu_open_icon group-hover:opacity-50 w-10 max-sm:w-9"
        width="40"
        height="40"
      />
      <img
        src={`${pathRoot}/assets/images/common/menu.svg`}
        alt="menu_open"
        className="mt-2 menu_open_icon"
        width="38"
        height="6"
      />
    </Box>
  );
}
